export default __webpack_public_path__ + "static/media/transpose.f34b4729.png";